import { keepPreviousData, QueryClient } from '@tanstack/react-query';

// import type { Paginator } from '_types/laravel';

export const apiSwr = new QueryClient({
    defaultOptions: {
        queries: {
            experimental_prefetchInRender: true,
            placeholderData: keepPreviousData,
            refetchOnMount: true,
            refetchOnWindowFocus: true,
        },
        mutations: {
            throwOnError: false,
        },
    },
});

// export const getPreviousPageParam = (lastPage: unknown) => {
//     if (!lastPage || typeof lastPage !== 'object' || !('meta' in lastPage)) return null;
//
//     const { meta } = lastPage as Paginator;
//     const current = meta.current_page;
//
//     return current === 1 ? null : current - 1;
// };
//
// export const getNextPageParam = (lastPage: unknown) => {
//     if (!lastPage || typeof lastPage !== 'object' || !('meta' in lastPage)) return null;
//
//     const { meta } = lastPage as Paginator;
//     const last = meta.last_page;
//     const current = meta.current_page;
//
//     return current === last ? null : current + 1;
// };
